/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { UtilsService } from 'app/shared/services';

@Directive({
  selector: '[appDateFormat]',
})
export class DateFormatDirective {
  constructor(private el: ElementRef, private control: NgControl, private utilsService: UtilsService) {}

  @HostListener('input') onInput() {
    // let selectionStart = this.el.nativeElement.selectionStart;
    // let selectionEnd = this.el.nativeElement.selectionEnd;
    const value = this.el.nativeElement.value;

    const newValue = UtilsService.formatDate(value);

    this.el.nativeElement.value = newValue;
    // this.el.nativeElement.selectionStart = selectionStart;
    // this.el.nativeElement.selectionEnd = selectionEnd;
    this.control.control.setValue(newValue);
  }
}
